import { render, staticRenderFns } from "./logisticdetail.vue?vue&type=template&id=179a9bb4"
import script from "./logisticdetail.vue?vue&type=script&lang=js"
export * from "./logisticdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports